import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "@/lib/api";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import { DialogTitle } from "@/components/ui/dialog";
import { Bot, ListTodo, ShieldCheck, FolderLock, UploadCloud, Building2 } from "lucide-react";

const ICONS = {
  agent: Bot, task: ListTodo, approval: ShieldCheck, document: FolderLock,
  upload: UploadCloud, brand: Building2,
};

export default function CommandPalette({ open, setOpen }) {
  const api = useApi();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const data = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setResults(data.results || []);
      } catch (e) { setResults([]); }
    }, 220);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  const go = (route) => {
    setOpen(false);
    setQ("");
    navigate(route);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <DialogTitle className="sr-only">Command search</DialogTitle>
      <CommandInput
        placeholder="Search agents, approvals, tasks, documents…"
        value={q}
        onValueChange={setQ}
        data-testid="command-search-input"
      />
      <CommandList>
        <CommandEmpty>{q ? "No matches found." : "Type to search across the command centre."}</CommandEmpty>
        {results.length > 0 && (
          <CommandGroup heading="Results">
            {results.map((r) => {
              const Icon = ICONS[r.type] || Bot;
              return (
                <CommandItem
                  key={`${r.type}-${r.id}`}
                  value={`${r.title} ${r.id}`}
                  onSelect={() => go(r.route)}
                  data-testid={`search-result-${r.type}`}
                  className="flex items-center gap-2.5 cursor-pointer"
                >
                  <Icon className="h-4 w-4 text-muted-foreground" />
                  <span className="flex-1">{r.title}</span>
                  <span className="text-[10px] font-mono uppercase text-muted-foreground">{r.type}</span>
                </CommandItem>
              );
            })}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
